import { Link } from "react-router-dom";
import type { Program } from "@/mocks/skincare";

export default function ProgramDetail({ program, index }: { program: Program; index: number }) {
  const isEven = index % 2 === 0;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
      {/* 이미지 */}
      <div className={`relative ${isEven ? "lg:order-1" : "lg:order-2"}`}>
        <img
          src={program.image}
          alt={`${program.name} 피부관리 프로그램`}
          title={`${program.name} - 비앙카 피부관리`}
          className="w-full h-auto object-cover object-top rounded-3xl"
        />
        <span className="absolute top-4 right-4 px-3 py-1.5 rounded-full bg-white/90 backdrop-blur-sm text-sm font-medium text-foreground-700">
          {program.duration}
        </span>
      </div>

      {/* 내용 */}
      <div className={`flex flex-col gap-6 ${isEven ? "lg:order-2" : "lg:order-1"}`}>
        <div className="flex flex-col gap-2">
          <span className="text-[11px] font-medium tracking-[0.15em] uppercase text-primary-500">
            {program.english}
          </span>
          <h3 className="text-2xl md:text-3xl font-bold text-foreground-900">{program.name}</h3>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{program.description}</p>
        </div>

        {/* 관리 과정 */}
        <div className="flex flex-col gap-3">
          <span className="text-sm font-semibold text-foreground-900">관리 과정</span>
          <div className="flex items-center flex-wrap gap-2">
            {program.steps.map((step, i) => (
              <div key={step} className="flex items-center gap-2">
                <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary-50 text-primary-700 text-sm font-medium whitespace-nowrap">
                  <span className="text-xs font-bold">{i + 1}</span>
                  {step}
                </span>
                {i < program.steps.length - 1 && (
                  <i className="ri-arrow-right-s-line text-foreground-300"></i>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* 기대 효과 */}
        <div className="flex flex-col gap-3">
          <span className="text-sm font-semibold text-foreground-900">기대 효과</span>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {program.benefits.map((benefit) => (
              <li key={benefit} className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-check-line text-secondary-600 mt-0.5"></i>
                <span className="leading-relaxed">{benefit}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* 추천 대상 */}
        <div className="flex flex-col gap-3">
          <span className="text-sm font-semibold text-foreground-900">이런 분께 추천해요</span>
          <ul className="flex flex-col gap-2">
            {program.recommendedFor.map((target) => (
              <li key={target} className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-heart-3-line text-primary-500 mt-0.5"></i>
                <span className="leading-relaxed">{target}</span>
              </li>
            ))}
          </ul>
        </div>

        <Link
          to="/reservation"
          className="mt-1 inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold whitespace-nowrap transition-all hover:bg-primary-600 cursor-pointer w-fit"
        >
          이 프로그램 예약하기
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </div>
  );
}